import React, { useCallback } from 'react';
import { Button } from '@mui/material';

import { LogLinkApi } from '../../../../../api';
import modalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import { scDarkBlue100 } from '../../../../../constants/systemColors';
import { onRequestError } from '../../../../../services/handlers';
import { LinkedParticipantsModal } from '../../shared/Review/ReviewContent/LogItemGroupElement/LogItemGroupContent/LinkedParticipantsButton/LinkParticipantsModal/LinkedParticipantsModal';
import { getUrlToPatientInfoPage } from '../../shared/Worklist/WorklistService';

export const LinkedSubjectsButton = ({ row, worklistName }) => {
  const generateUrlToPatientInfoPage = useCallback(
    row =>
      getUrlToPatientInfoPage(
        {
          ...row,
          patientIdentifier: row.patientUniqueId
        },
        worklistName
      ),
    [worklistName]
  );

  const onButtonClick = useCallback(() => {
    LogLinkApi.getLinkedParticipantForReview({
      studyId: row.studyIdentifier,
      ssuPatientId: row.ssuPatientId,
      itemGroupTemplateId: row.itemGroupTemplateId,
      itemGroupTemplateVersionId: row.itemGroupTemplateVersionId,
      rowId: row.rowId,
      review: worklistName === 'Study Manager Worklist' ? 'SM' : 'PI'
    }).then(({ data }) => {
      modalBoxes.open({
        title: 'Linked Subjects',
        component: (
          <LinkedParticipantsModal
            participants={data}
            showPatientColumn={true}
            generateUrlToPatientInfoPage={generateUrlToPatientInfoPage}
          />
        ),
        className: 'linked-participants-modal',
        size: 'w1100'
      });
    }, onRequestError);
  }, [row, worklistName, generateUrlToPatientInfoPage]);
  return (
    <Button
      type="text"
      sx={{
        textTransform: 'none',
        color: scDarkBlue100,
        fontWeight: 400,
        minWidth: 'min-content',
        padding: 0
      }}
      onClick={onButtonClick}
    >
      Multiple
    </Button>
  );
};
